import { render, staticRenderFns } from "./EmpresaExterna.vue?vue&type=template&id=121045a4"
import script from "./EmpresaExterna.vue?vue&type=script&lang=js"
export * from "./EmpresaExterna.vue?vue&type=script&lang=js"
import style0 from "./EmpresaExterna.vue?vue&type=style&index=0&id=121045a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports